<div class="modal-header">
    <h4 class="modal-title" id="modal-representante-title">
        Detalles del Representante
    </h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="activeModal.dismiss('Cierre con X')"></button>
</div>
<div class="modal-body">
    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando información...</p>
    </div>

    <div *ngIf="errorMessage && !representante" class="alert alert-warning">
        {{ errorMessage }}
    </div>

    <div *ngIf="representante">
        <dl class="row">
            <dt class="col-sm-4">Nombre usuario:</dt>
            <dd class="col-sm-8">{{ representante.username || 'N/A' }}</dd>

            <dt class="col-sm-4">Nombre completo:</dt>
            <dd class="col-sm-8">{{ getNombreCompleto() }}</dd>

            <dt class="col-sm-4">Correo electrónico:</dt>
            <dd class="col-sm-8">{{ representante.email || 'N/A' }}</dd>

            <dt class="col-sm-4">Estado:</dt>
            <dd class="col-sm-8">{{ representante.estado || 'N/A' }}</dd>

            <dt class="col-sm-4">Cargo:</dt>
            <dd class="col-sm-8">{{ representante.cargo || 'N/A' }}</dd>

            <dt class="col-sm-4">Teléfono:</dt>
            <dd class="col-sm-8">{{ representante.telefono || 'N/A' }}</dd>
        </dl>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="activeModal.close('Cerrar click')">
        Cerrar
    </button>
</div>
